import { Link } from 'react-router-dom';
import Seo from '../../components/Seo';
import PageHero from '../../components/PageHero';
import { useAsync } from '../../lib/useAsync';
import { activitiesApi } from '../../api/resources';
import { SkeletonGrid, ErrorState, EmptyState } from '../../components/ui';
import { assetUrl } from '../../api/client';
import { truncate, formatDate } from '../../lib/format';

export default function ActivityList() {
  const { data, loading, error, reload } = useAsync(() => activitiesApi.list({ per_page: 12 }), []);

  return (
    <>
      <Seo title="Activities" description="Community service activities and initiatives by Zonta District 17 Area 1." />
      <PageHero
        eyebrow="In Our Community"
        title="Service in action"
        subtitle="Service projects and initiatives making a difference in our community."
        image="/img/unity-hands.jpg"
      />

      <section className="container-page py-12">
        {loading ? (
          // Mirrors the loaded `sm:grid-cols-2 lg:grid-cols-3` grid below.
          <SkeletonGrid count={6} columns="1-2-3" gap={6} />
        ) : error ? (
          <ErrorState error={error} onRetry={reload} />
        ) : data?.items?.length ? (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {data.items.map((a) => {
              const img =
                assetUrl(a.first_image_url || a.featured_image_path || a.image_path) || '/img/story-a.jpg';
              return (
                <Link key={a.id} to={`/activities/${a.slug}`} className="card card-hover group overflow-hidden">
                  <div className="aspect-[16/10] overflow-hidden bg-maroon-50">
                    <img
                      src={img}
                      alt={a.title}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-5">
                    {a.starts_at && <p className="text-xs text-ink-muted">{formatDate(a.starts_at)}</p>}
                    <h3 className="mt-1 font-display text-lg font-bold leading-snug text-ink transition-colors group-hover:text-maroon-700">
                      {a.title}
                    </h3>
                    <p className="mt-2 text-sm text-ink-muted">{truncate(a.excerpt || a.summary || a.description, 120)}</p>
                  </div>
                </Link>
              );
            })}
          </div>
        ) : (
          <EmptyState icon="🤝" title="No activities yet" message="Check back soon for upcoming community activities." />
        )}
      </section>
    </>
  );
}
